<template>
  <div class="framePage">
    <iframe name="iframe" :src="src" frameborder="0" width="100%" :height="fullHeight"></iframe>
  </div>
</template>

<script>
export default {
  name: 'iframe',
  data() {
    return {
      fullHeight: document.documentElement.clientHeight - 50,
      src: '',
    };
  },
  created() {
    let { typeurl, grpPolicyNo, mobileNo } = this.$route.query;
    // typeurl  :1 保全管理 2:保全历史
    if (process.env.NODE_ENV == 'sta'||process.env.NODE_ENV == 'uat') {
      typeurl == 1
        ? (this.src = `http://www-int2.sino-life.com/SL_GES/pub/posApply/gpsApplyPage.do?grpPolicyNo=${grpPolicyNo}&mobileNo=${mobileNo}`)
        :this.src =`http://www-int2.sino-life.com/SL_GES/pub/group/toPosInfoList?grpPolicyNo=${grpPolicyNo}&mobileNo=${mobileNo}`;
    } else {
      typeurl == 1
        ? (this.src = `http://www.sino-life.com/SL_GES/pub/posApply/gpsApplyPage.do?grpPolicyNo=${grpPolicyNo}&mobileNo=${mobileNo}`)
        :this.src =`http://www.sino-life.com/SL_GES/pub/group/toPosInfoList?grpPolicyNo=${grpPolicyNo}&mobileNo=${mobileNo}`;
    }
  },
};
</script>
<style>
.framePage {
  overflow: hidden;
  height: 100%;
}
</style>
